import { isAudio, isImage, isPDF, isVideo } from "@utils/fileUtils"

import { FileDisplayProps } from "./FileDisplay.types"
import AudioPlayer from "./Viewers/AudioPlayer/AudioPlayer"
import DocumentDownload from "./Viewers/DocumentDownload/DocumentDownload"
import ImageViewer from "./Viewers/ImageViewer/ImageViewer"
import PDFViewer from "./Viewers/PDFViewer/PDFViewer"
import VideoPlayer from "./Viewers/VideoPlayer/VideoPlayer"

export default function FileDisplay(props: FileDisplayProps) {
    const { attachment, className } = props

    const mimeType = attachment.upload_mimetype
    const filename = attachment.upload_filename

    if (isImage(mimeType)) {
        return <ImageViewer src={attachment.signed_url} alt={filename} className={className} />
    } else if (isVideo(mimeType)) {
        // Keyed so switching attachments remounts the player — Plyr can't re-initialize in place
        return (
            <VideoPlayer
                key={attachment.id}
                src={attachment.signed_url}
                streamingSrc={attachment.streaming_url}
                filename={filename}
                className={className}
            />
        )
    } else if (isAudio(mimeType)) {
        return (
            <AudioPlayer
                key={attachment.id}
                src={attachment.signed_url}
                streamingSrc={attachment.streaming_url}
                filename={filename}
                className={className}
            />
        )
    } else if (isPDF(mimeType)) {
        return <PDFViewer src={attachment.signed_url} filename={filename} className={className} />
    } else {
        return (
            <DocumentDownload
                src={attachment.signed_url}
                filename={filename}
                mimeType={mimeType}
                className={className}
            />
        )
    }
}
